import { Dispatch, KeyboardEvent, SetStateAction } from "react";
import { FocusedItem, Option } from "./types";
import { getActiveElement } from "../../../internal/functions";

export const listViewKeyboardNavigation = (
  e: KeyboardEvent<HTMLDivElement>,
  options: Option[],
  focusedItem: FocusedItem,
  setFocusedItem: Dispatch<SetStateAction<FocusedItem>>,
  parent: HTMLDivElement | null,
  currentFocusId: (id: string) => void,
) => {
  if (!options) return;
  let activeElement: HTMLElement | null;
  switch (e.code) {
    case "Enter":
    case "Space":
      (
        options[focusedItem.row].focusables[focusedItem.col] as HTMLElement
      ).click();
      activeElement = getActiveElement(document);
      if (!activeElement) break;
      activeElement.click();
      e.preventDefault();
      break;
    case "ArrowDown":
      parent?.focus();
      options[focusedItem.row].focusables[focusedItem.col].removeAttribute(
        "data-interactive",
      );
      if (focusedItem.row === options.length - 1) {
        options[0].focusables[focusedItem.col].setAttribute(
          "data-interactive",
          "focus-visible",
        );
        currentFocusId(options[0].focusables[focusedItem.col].id);
        setFocusedItem((prev) => {
          return { ...prev, row: 0 };
        });
        break;
      }

      options[focusedItem.row + 1].focusables[focusedItem.col].setAttribute(
        "data-interactive",
        "focus-visible",
      );
      currentFocusId(
        options[focusedItem.row + 1].focusables[focusedItem.col].id,
      );
      setFocusedItem((prev) => {
        return { ...prev, row: focusedItem.row + 1 };
      });
      break;
    case "ArrowUp":
      parent?.focus();
      options[focusedItem.row].focusables[focusedItem.col].removeAttribute(
        "data-interactive",
      );
      if (focusedItem.row === 0) {
        options[options.length - 1].focusables[focusedItem.col].setAttribute(
          "data-interactive",
          "focus-visible",
        );
        currentFocusId(
          options[options.length - 1].focusables[focusedItem.col].id,
        );
        setFocusedItem((prev) => {
          return { ...prev, row: options.length - 1 };
        });
        break;
      }

      options[focusedItem.row - 1].focusables[focusedItem.col].setAttribute(
        "data-interactive",
        "focus-visible",
      );
      currentFocusId(
        options[focusedItem.row - 1].focusables[focusedItem.col].id,
      );
      setFocusedItem((prev) => {
        return { ...prev, row: focusedItem.row - 1 };
      });
      break;
    case "ArrowRight":
      parent?.focus();
      options[focusedItem.row].focusables[focusedItem.col].removeAttribute(
        "data-interactive",
      );
      if (focusedItem.col === options[focusedItem.row].focusables.length - 1) {
        options[focusedItem.row].focusables[0].setAttribute(
          "data-interactive",
          "focus-visible",
        );
        currentFocusId(options[focusedItem.row].focusables[0].id);
        setFocusedItem((prev) => {
          return {
            ...prev,
            col: 0,
          };
        });
        break;
      }

      options[focusedItem.row].focusables[focusedItem.col + 1].setAttribute(
        "data-interactive",
        "focus-visible",
      );
      currentFocusId(
        options[focusedItem.row].focusables[focusedItem.col + 1].id,
      );
      setFocusedItem((prev) => {
        return { ...prev, col: focusedItem.col + 1 };
      });
      break;
    case "ArrowLeft":
      parent?.focus();
      options[focusedItem.row].focusables[focusedItem.col].removeAttribute(
        "data-interactive",
      );
      if (focusedItem.col === 0) {
        options[focusedItem.row].focusables[
          options[focusedItem.row].focusables.length - 1
        ].setAttribute("data-interactive", "focus-visible");
        currentFocusId(
          options[focusedItem.row].focusables[
            options[focusedItem.row].focusables.length - 1
          ].id,
        );
        setFocusedItem((prev) => {
          return {
            ...prev,
            col: options[focusedItem.row].focusables.length - 1,
          };
        });
        break;
      }

      options[focusedItem.row].focusables[focusedItem.col - 1].setAttribute(
        "data-interactive",
        "focus-visible",
      );
      currentFocusId(
        options[focusedItem.row].focusables[focusedItem.col - 1].id,
      );
      setFocusedItem((prev) => {
        return { ...prev, col: focusedItem.col - 1 };
      });
      break;

    default:
      break;
  }
};

export const getFocusables = (el: Element) => {
  return el.querySelectorAll(
    "button:not(:disabled):not([aria-disabled='true']), input:not(:disabled):not([aria-disabled='true']), [tabindex='0']:not(:disabled):not([aria-disabled='true'])",
  );
};
